import { useState } from "react";
import * as BsIcons from "react-icons/bs";
import RowReserva from "../ShowTable/RowReserva";
import ShowTable from "../ShowTable";
import {translate} from "../../utils/Common";

import './index.css';
import ItemSearchPackage from "../ShowTable/ItemSearchPackage";
import { FaClock, FaTruckLoading } from "react-icons/fa";
import { IoMdContact } from "react-icons/io";
import { PiLockersFill } from "react-icons/pi";
const Results = ({ ItemComponent, itemsFound, itemName, setSelectedItem, showBox, actualPage, itemsShowing, view, handleUpdateData, typeList, visibleColumns, renderers, version }) => {
    const handleNoResults = () => {
        if (itemName === "reservas") return <p className="my-4">{translate("components.showItems.results.NOT_NEW_PACKAGES")}</p>
        else if (itemName === "entregas") return <p className="my-4">{translate("components.showItems.results.NOT_DELIVERY_PACKAGES")}</p>
        else if(itemName === "plataformas" ) return <p className="my-4">{translate("components.showItems.results.NOT_PLATFORMS")}</p>
        else return <p className="my-4"><BsIcons.BsEmojiFrown size={ 16 } className="mx-1" /> {translate("components.showItems.results.NOT_RESULTS")}</p>
    }


    const getItemList = (type) => {
        const objDefault = {
            item: RowReserva,
            headerRow: (
            <tr>
                <th>#</th>
                <th>{translate("global.numIdentity")}</th>
                <th>{translate("global.ubication")}</th>
                <th>{translate("global.codeQR")}</th>
            </tr>
            )
        };

        switch (type) {
            case "pkgs-reserv":
                return objDefault;
            case "pkgs-search":
                return {
                    item: ItemSearchPackage,
                    headerRow: (
                    <tr>
                        <th>#</th>
                        <th>ID {translate("global.Package")}</th>
                        <th><BsIcons.BsBoxSeam className="mr-1" size={16}/> {translate("global.numPackage")}</th>
                        <th><FaTruckLoading className="mr-1" size={16}/> {translate("global.numTracking")}</th>
                        <th><IoMdContact className="mr-1" size={18}/> {translate("global.client")}</th>
                        <th><FaClock className="mr-1" size={14}/>{translate("global.status")}</th>
                        <th><PiLockersFill className="mr-1" size={18} /> {translate("global.ubication")}</th>
                    </tr>
                    )
                };
            default:
                return objDefault;
        }
    }

    return (
        <>
            { view === 'grid' ?
                (itemsFound?.length > 0 ?
                    <div className="px-4">
                        <div className="responsive-grid">
                            {   itemsFound?.map((paquete, index) => 
                                (index >= ((actualPage * itemsShowing) - itemsShowing) &&
                                index < (actualPage * itemsShowing)) &&
                                    <ItemComponent
                                        key={ index }
                                        itemName={ itemName}
                                        index={ index }
                                        showBox={ showBox } 
                                        item={ paquete }
                                        setSelectedItem={ setSelectedItem } 
                                        handleUpdateData={handleUpdateData}/>
                            )}
                        </div>
                    </div>
                    :
                    <div className="dashboardCard text-center">
                        {handleNoResults()}
                    </div>
                )
                :
                <div className="dashboardCard p-0">
                    <ShowTable 
                        itemArray={itemsFound}
                        headerRow={getItemList(typeList).headerRow}
                        Item={getItemList(typeList).item}
                        selectItem={setSelectedItem}
                        noItemsFound={handleNoResults()}
                        actualPage={actualPage}
                        itemsShowing={itemsShowing}
                        size='md'
                        visibleColumns={visibleColumns}
                        renderers={renderers}
                        version={version}
                        />
                </div>
            }
        </>
    );
}

export default Results;